/* eslint-disable no-unused-expressions */
/* eslint-disable no-lone-blocks */
import Grid from "@material-ui/core/Grid";
import Step from "@mui/material/Step";
import StepLabel from "@mui/material/StepLabel";
import Stepper from "@mui/material/Stepper";
import OrderFieldSvg from "assets/icons/svg/orderFields";
import ParametereValuesSvg from "assets/icons/svg/parametereValues";
import PointerSvgComponent from "assets/icons/svg/pointer";
import ResultsSvgComponent from "assets/icons/svg/results";
import NotAuthorized from "components/NotAuthorized";
import { useFormik } from "formik";
import { useDisableEnterKey } from "hook";
import { SubHeader } from "layout/SubHeader";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { AudienceInformation } from "./AudienceInformation";
import { filterState, reset } from "./filterSlice";
import "./index.scss";
import ParameterValue from "./parameterValue";
import SearchResult from "./result";

const CreateNewCommunicationFilter = ({
  setRefresh,
  audienceRow,
  closeModal,
}) => {
  const dispatch = useDispatch();
  const getFilterState = useSelector((state) => state.filterParams.search);
  const [search, setSearch] = useState("audience-info");
  const [isReportActive, setIsReportActive] = useState(true);
  const id = audienceRow ? audienceRow?.id : null;
  console.log("audienceRow", audienceRow, id);

  const [getPreviousVal, setGetPreviosuVal] = useState(true);

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      name: audienceRow?.name || "",
      note: audienceRow?.description || "",
    },
    validationSchema: "",
  });

  const renderTabContent = () => {
    switch (search) {
      case "audience-info":
        return (
          <AudienceInformation
            onClick={() => setSearch("parameter")}
            id={id}
            formik={formik}
            audienceRow={audienceRow}
          />
        );
      case "parameter":
        return (
          <ParameterValue
            formik={formik}
            onClick={() => setSearch("results")}
            id={id}
            audienceRow={audienceRow}
            getPreviousVal={getPreviousVal}
            goToInfo={() => setSearch("audience-info")}
          />
        );
      case "results":
        return (
          <SearchResult
            id={id}
            goToParameter={() => setSearch("parameter")}
            formik={formik}
            closeModal={closeModal}
            setRefresh={setRefresh}
          />
        );
      default:
        return;
    }
  };

  useEffect(() => {
    dispatch(filterState(search));
  }, [dispatch, search]);

  useEffect(() => {
    return () => {
      dispatch(reset());
    };
  }, [dispatch]);
  let orgInfo =
    localStorage.getItem("authorizedModules") !== undefined
      ? JSON.parse(localStorage.getItem("authorizedModules"))
      : [];

  useEffect(() => {
    let check = orgInfo?.map((item) => {
      if (item?.moduleName == "report") {
        return setIsReportActive(item?.active);
      }
    });
  }, []);

  useDisableEnterKey(true)


  return isReportActive === false ? (
    <NotAuthorized title={"Reports"} />
  ) : (
    <div className="create-filter">
      <div className="filter-details">
        <div className="class_steps_audience">
          <Stepper
            activeStep={
              search === "audience-info" ? 0 : search === "parameter" ? 1 : 2
            }
          >
            <Step
              completed={search === "parameter" || search === "results"}
              className="step"
            >
              <StepLabel className="step-label">Audience Information</StepLabel>
            </Step>
            <Step completed={search === "results"}>
              <StepLabel>Parameters & Values</StepLabel>
            </Step>
            <Step>
              <StepLabel>Results</StepLabel>
            </Step>
          </Stepper>
        </div>

        <div className="filter-container">{renderTabContent()}</div>
      </div>
    </div>
  );
};

export default CreateNewCommunicationFilter;
